var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-callback"},[(_vm.loading)?[_c('loader',{attrs:{"width":"48px","height":"48px","stroke":"#4C4C4C"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }